import ManageClientsTable from './tables/Table';

export default ManageClientsTable;
